'use client';

import { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

const MarketingNavContext = createContext(null);

const megaMenuShape = PropTypes.shape({
  items: PropTypes.arrayOf(
    PropTypes.shape({
      itemKey: PropTypes.string,
      label: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      image: PropTypes.shape({
        src: PropTypes.string.isRequired,
        alt: PropTypes.string,
      }),
    }),
  ).isRequired,
});

export function MarketingNavProvider({ marketingNav, children }) {
  const value = useMemo(() => marketingNav, [marketingNav]);
  return <MarketingNavContext.Provider value={value}>{children}</MarketingNavContext.Provider>;
}

MarketingNavProvider.propTypes = {
  marketingNav: PropTypes.shape({
    newsMedia: megaMenuShape.isRequired,
    trade: megaMenuShape.isRequired,
    studio: megaMenuShape.isRequired,
  }).isRequired,
  children: PropTypes.node.isRequired,
};

export function useMarketingNav() {
  const context = useContext(MarketingNavContext);
  if (!context) {
    throw new Error('useMarketingNav must be used within MarketingNavProvider');
  }
  return context;
}

export function useMarketingNavMegaMenu(menuKey) {
  const nav = useMarketingNav();
  return nav[menuKey];
}
